import { createSlice } from "@reduxjs/toolkit";

const areasSlice = createSlice({
  name: "areas",
  initialState: [],
  reducers: {
    addAreasList: (state, action) => action.payload,
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = areasSlice;

// Extract and export each action creator by name
export const { addAreasList } = actions;

// Export the reducer, either as a default or named export
export default reducer;
